/* Youtube Videos - This line cannot be edited or removed */
export const GET_YOUTUBE_VIDEOS = "GET_YOUTUBE_VIDEOS"
export const GET_YOUTUBE_VIDEOS_SUCCESS = "GET_YOUTUBE_VIDEOS_SUCCESS"
export const GET_YOUTUBE_VIDEOS_FAIL = "GET_YOUTUBE_VIDEOS_FAIL"

/* Youtube Videos DETAILS */
export const GET_YOUTUBE_VIDEO_DETAILS = "GET_YOUTUBE_VIDEO_DETAILS"
export const GET_YOUTUBE_VIDEO_DETAILS_SUCCESS = "GET_YOUTUBE_VIDEO_DETAILS_SUCCESS"
export const GET_YOUTUBE_VIDEO_DETAILS_FAIL = "GET_YOUTUBE_VIDEO_DETAILS_FAIL"

/* CREATE Youtube Videos */
export const CREATE_YOUTUBE_VIDEO = "CREATE_YOUTUBE_VIDEO"
export const CREATE_YOUTUBE_VIDEO_SUCCESS = "CREATE_YOUTUBE_VIDEO_SUCCESS"
export const CREATE_YOUTUBE_VIDEO_FAIL = "CREATE_YOUTUBE_VIDEO_FAIL"

/* Edit Youtube Videos */
export const UPDATE_YOUTUBE_VIDEO = "UPDATE_YOUTUBE_VIDEO"
export const UPDATE_YOUTUBE_VIDEO_SUCCESS = "UPDATE_YOUTUBE_VIDEO_SUCCESS"
export const UPDATE_YOUTUBE_VIDEO_FAIL = "UPDATE_YOUTUBE_VIDEO_FAIL"

/* Delete Youtube Videos */
export const DELETE_YOUTUBE_VIDEO = "DELETE_YOUTUBE_VIDEO"
export const DELETE_YOUTUBE_VIDEO_SUCCESS = "DELETE_YOUTUBE_VIDEO_SUCCESS"
export const DELETE_YOUTUBE_VIDEO_FAIL = "DELETE_YOUTUBE_VIDEO_FAIL"

